<template>
  <Modal v-model="showModal"
    scrollable
    fullscreen
    :mask="true"
    :mask-closable="false"
    @on-cancel="closeModal"
    @submit="closeModal"
    title="预览">
    <div v-if="showModal" class="modal-main">
      <Spin fix v-if="isIniting" style="z-index:50">
        <Progress :percent="initingPercentage" style="width:360px" />
        <div>加载中...初始化页面</div>
      </Spin>
      <div class="page-previewer-toolbar">
        <div class="page-previewer-pager">
          <span>
            第 {{currentPageNum}} 页 / 总 {{totalPageCount}} 页
          </span>
          <span style="margin-left:10px;">
            <Button @click="currentPageNum--" :disabled="currentPageNum<=1" size="small" icon="ios-arrow-back"></Button>
            <Button @click="currentPageNum++" :disabled="currentPageNum>=totalPageCount" style="margin-left:5px;" size="small" icon="ios-arrow-forward"></Button>
          </span>
        </div>
        <Divider type="vertical" />
        <div class="page-previewer-zoom">
          <Button @click="zoomOut" :disabled="curZoomLevel<=0" size="small" icon="md-remove"></Button>
          <Input :value="ratioPercentage+'%'" readonly size="small" style="width:80px">
            <Icon type="ios-search" slot="prefix" />
            <span slot="surffix">%</span>
          </Input>
          <Button @click="zoomIn" :disabled="curZoomLevel>=zoomLevels.length-1" size="small" icon="md-add"></Button>
        </div>
      </div>
      <div class="page-previewer-container">
        <div class="page-previewer-window" ref="pagePreviewerWindow" :style="{width:pageWidth+'px',height:pageHeight+'px'}">
          <div class="page" ref="pagePreviewerPage" :style="{width:pageWidth+'px',height:pageHeight+'px',padding:pageMargin+'px'}">
            <div class="page-view" v-html="content" ref="pagePreviewerPageView" :style="{paddingBottom:pixesNeedToPadBelow+'px'}"></div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button type="primary" @click="closeModal">确定</Button>
      <Button @click="closeModal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import html2canvas from 'html2canvas'
export default {
  name: 'html-preview-modal',
  props: {
    callback: Function,
    show: Boolean,
    content: String
  },
  components: {
  },
  data () {
    return {
      isIniting: false,
      initingPercentage: 0,
      curZoomLevel: 9,
      zoomLevels: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200],
      pageHeightInit: 842,
      pageWidthInit: 595,
      pageMarginInit: 36,
      showModal: false,
      html: null,
      totalPageCount: 0,
      currentPageNum: 0,
      pixesNeedToPadBelow: 0,
      canvasArr: []
    }
  },
  computed: {
    ratioPercentage: function () {
      return this.zoomLevels[this.curZoomLevel]
    },
    ratio: function () {
      return this.ratioPercentage / 100
    },
    pageHeight: function () {
      return this.pageHeightInit * this.ratio
    },
    pageWidth: function () {
      return this.pageWidthInit * this.ratio
    },
    pageMargin: function () {
      return this.pageMarginInit * this.ratio
    }
  },
  watch: {
    show: function (newVal) {
      if (this.content && newVal) {
        this.html = this.content
        this.$nextTick(() => {
          this.initCanvas()
          // this.calcTotalPageCount()
          // this.currentPageNum = 1
        })
      }
      this.showModal = newVal
    },
    currentPageNum: function () {
      this.jumpToPage()
    },
    curZoomLevel: function (newVal) {
      if (newVal <= 0) {
        this.curZoomLevel = 0
      } else if (newVal >= this.zoomLevels.length - 1) {
        this.curZoomLevel = this.zoomLevels.length - 1
      } else {
        window.less.modifyVars({
          '@pagePreviewerZoom': this.ratio
        })
        this.pixesNeedToPadBelow = 0
        // this.calcTotalPageCount()
      }
    }
  },
  methods: {
    initCanvas () {
      this.initingPercentage = 0
      this.isIniting = true
      this.calcTotalPageCount()
      this.$nextTick(() => {
        this.queue().then((arr) => {
          console.log(arr)
          this.$refs.pagePreviewerPageView.scrollTop = 0
          this.$refs.pagePreviewerPageView.innerHTML = ''
          arr.forEach((canv) => {
            this.$refs.pagePreviewerPageView.append(canv)
          })
          this.currentPageNum = 1
          this.initingPercentage = 100
          this.isIniting = false
        })
      })
    },
    // 构建队列
    async queue () {
      let res = []
      for (let i = 0; i < this.totalPageCount;) {
        console.log('init page' + (i + 1))
        await (() => {
          return new Promise((resolve, reject) => {
            this.preparePage(i + 1).then((qResult) => {
              this.initingPercentage = (i + 1) / this.totalPageCount * 100
              resolve(qResult)
            }).catch(e => {
              reject(e)
            })
          })
        })().then((data) => {
          res.push(data)
          i++
        }).catch(err => {
          throw err
        })
        if (i >= this.totalPageCount) {
          return Promise.resolve(res)
        }
      }
    },
    preparePage (pageIndex) {
      return new Promise((resolve, reject) => {
        this.jumpToPage(pageIndex)
        this.$nextTick(() => {
          html2canvas(this.$refs.pagePreviewerPageView).then((canvas) => {
            setTimeout(() => {
              this.canvasArr.push(canvas)
              // console.log(pageIndex, 'resolve', canvas)
              resolve(canvas)
            }, 200)
          }).catch(err => {
            reject(err)
          })
        })
      })
    },
    zoomOut () {
      this.curZoomLevel--
    },
    zoomIn () {
      this.curZoomLevel++
    },
    jumpToPage (pageIndex) {
      let viewHeight = this.$refs.pagePreviewerPageView.clientHeight
      let pixesNeedToRoll = ((pageIndex || this.currentPageNum) - 1) * viewHeight
      // console.log(pageIndex, pixesNeedToRoll)
      this.$refs.pagePreviewerPageView.scrollTop = pixesNeedToRoll
    },
    calcTotalPageCount () {
      this.pixesNeedToPadBelow = 0
      this.$nextTick(() => {
        let viewHeight = this.$refs.pagePreviewerPageView.clientHeight
        let contentHeight = this.$refs.pagePreviewerPageView.scrollHeight
        this.totalPageCount = Math.ceil(contentHeight / viewHeight)
        // console.log(viewHeight, contentHeight, this.totalPageCount)
        if (this.totalPageCount > 1) {
          this.pixesNeedToPadBelow = viewHeight - (contentHeight % viewHeight)
        }
      })
    },
    closeModal () {
      this.curZoomLevel = 9
      this.currentPageNum = 0
      this.pixesNeedToPadBelow = 0
      this.totalPageCount = 0
      this.html = null
      this.showModal = false
      this.$emit('close-modal')
    }
  }
}
</script>

<style lang="less" scoped>
.modal-main {
  position: relative;
  height: 100%;
  width: 100%;
  background: #e2e2e2;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .page-previewer-toolbar {
    background: rgb(92, 92, 92);
    width: 100%;
    padding: 5px 16px;
    z-index: 11;
    color: #efefef;
    display: flex;
    flex-direction: row;
    align-items: center;
    .page-previewer-zoom {
      width: 136px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }
  .page-previewer-container {
    flex: 1;
    position: relative;
    height: 100%;
    width: 100%;
    padding: 50px;
    overflow: auto;
    .page-previewer-window {
      position: relative;
      margin: auto;
      width: 595px;
      height: 842px;
      .page {
        position: relative;
        margin: auto;
        width: 595px;
        height: 842px;
        padding: 36px;
        background: #fff;
        box-shadow: 3px 3px 0 #888;
        overflow: hidden;
        .page-view {
          position: relative;
          height: 100%;
          overflow: hidden;
          -webkit-touch-callout: none; /* iOS Safari */
          -webkit-user-select: none; /* Chrome/Safari/Opera */
          -khtml-user-select: none; /* Konqueror */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently not supported by any browser */
        }
      }
    }
  }
}
</style>
